import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as  api from "../../common/manipurCommon/API";
import * as  func from "../../common/manipurCommon/FunctionCalls";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import Utils from "../../common/manipurCommon/Utils";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const CompetitionsReport = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [coachList, setCoachList] = useState<any[]>([]);
    const [reportList, setReportList] = useState<any[]>([]);
    const [athleteId, setAthleteId] = useState("");
    const [coachId, setCoachId] = useState("");
    const [searchInput, setSearchInput] = useState("");


    useEffect(() => {
        async function fetchInitial() {
            setIsLoading(true);
            const athltResponse = await func.listAllActiveAthletes();
            setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
            const coachResponse = await func.listCoaches();
            setCoachList(Array.isArray(coachResponse) ? coachResponse : [])
            setIsLoading(false);
        }
        fetchInitial();
    }, [])

    function getReport(id: string, reportType: string) {
        let cmpRpt;
        if (reportType === "athlete") {
            cmpRpt = api.CompetitionReportByAthlete + "/" + id;
        } else {
            cmpRpt = api.CompetitionReportByCoach + "/" + id;
        }
        fetch(cmpRpt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setReportList(result.data)
                    setShowTable(true)
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                    setShowTable(false)
                }
            })
    }
    
    const filteredData = reportList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const competitionNameRender = (rowData) => {
        return <span>{rowData.competitionName}</span>
    };

    const sportCategoryNameRender = (rowData) => {
        return <span>{rowData.sportcategory}</span>
    };

    const sportNameRender = (rowData) => {
        return <span>{rowData.sportsName}</span>
    };
    
    const compCategoryNameRender = (rowData) => {
        return <span>{rowData.competitionCategoryName}</span>
    };

    const compClassNameRender = (rowData) => {
        return <span>{rowData.competitionClassName}</span>
    };
    
    const compFormatRender = (rowData) => {
        return <span>{rowData.competitionFormatName}</span>
    };

    const athletePerformanceStatisticRender = (rowData) => {
        return <span>{rowData.athleteperformancestat}</span>
    };

    const athleteRankRender = (rowData) => {
        return <span>{rowData.athleterank}</span>
    };

    const remarksRender = (rowData) => {
        return <span>{rowData.remarks}</span>
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competition Report</h4>
                                </div>
                                <hr className="mb-10" />
                            </div>
                            <div className="row">
                                <div className="col-lg-3 mb-10 input-space">
                                    <label className="form-label">Athlete</label>
                                    <Select
                                        value={athleteList.find(athlete => athlete.userId === athleteId) ? {
                                            value: athleteId,
                                            label: athleteList.find(athlete => athlete.userId === athleteId).athleteName
                                        } : null}
                                        onChange={async (e) => {
                                            setAthleteId(e.value);
                                            setCoachId("");
                                            getReport(e.value, "athlete");
                                        }}
                                        required
                                        placeholder="Select Athlete"
                                        options={athleteList.map(athlete => ({
                                            value: athlete.userId,
                                            label: athlete.athleteName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-3 mb-10 input-space">
                                    <label className="form-label">Coach</label>
                                    <Select
                                        value={coachList.find(coach => coach.userId === coachId) ? {
                                            value: coachId,
                                            label: coachList.find(coach => coach.userId === coachId).coachName
                                        } : null}
                                        onChange={async (e) => {
                                            setCoachId(e.value);
                                            setAthleteId("");
                                            getReport(e.value,"coach");
                                        }}
                                        required
                                        placeholder="Select Coach"
                                        options={coachList.map(coach => ({
                                            value: coach.userId,
                                            label: coach.coachName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div className="col-lg-12 col-sm-12 mb-10 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteName"
                                                    header="Athlete"
                                                    body={athleteNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="competitionName"
                                                    header="Competition Name"
                                                    body={competitionNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="competitionCategoryName"
                                                    header="Competition Category"
                                                    body={compCategoryNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="competitionClassName"
                                                    header="Competition Class"
                                                    body={compClassNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="competitionFormatName"
                                                    header="Competition Format"
                                                    body={compFormatRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportcategory"
                                                    header="Sport Category"
                                                    body={sportCategoryNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportName"
                                                    header="Sport"
                                                    body={sportNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteRank"
                                                    header="Athlete Rank"
                                                    body={athleteRankRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athletePerformanceStatistic"
                                                    header="Athlete Performance Statistic"
                                                    body={athletePerformanceStatisticRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="remarks"
                                                    header="Remarks"
                                                    body={remarksRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompetitionsReport;